import api from "./index";

export async function getDraws(params) {
  return api.get("/draws", { params });
}

export async function getDrawsHistory(params) {
  return api.get("/draws/history", { params });
}

export async function getItemDraw(itemID) {
  return api.get(`/draws/items/${itemID}`);
}
